import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Stethoscope } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { translations } from "../../i18n/translations";

const CTABanner = () => {
  const { lang } = useLanguage();
  const t = translations[lang].ctaBanner;

  return (
    <section className="bg-white py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-navy-900 px-8 py-14 lg:px-16 lg:py-16">
          <div className="absolute inset-0 dot-pattern opacity-30" />
          <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-amber-500/15 blur-[100px]" />
          <div className="relative flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
            <div className="max-w-2xl">
              <div className="w-14 h-14 rounded-2xl bg-amber-500/15 border border-amber-500/20 flex items-center justify-center mb-6">
                <Stethoscope className="w-7 h-7 text-amber-400" />
              </div>
              <h2 className="font-display font-bold text-3xl lg:text-4xl text-white leading-tight">
                {t.title}
              </h2>
              <p className="mt-4 text-slate-300 text-lg leading-relaxed">{t.desc}</p>
              <p className="mt-4 text-sm text-amber-400/90 font-medium">{t.note}</p>
            </div>
            <Link
              to="/iletisim"
              className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-navy-950 font-semibold px-8 py-4 rounded-xl transition-colors shadow-xl shadow-amber-500/25 shrink-0"
            >
              {t.button}
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
